Vgr.constants = {
	// !############################################
	// !não faça commit de alteração nessas constantes
	portalUrl: "http://localhost:5000",
	s3BaseUrl: "https://vgresiduos-bucket-dev.s3-sa-east-1.amazonaws.com/",
	newHostUrl: "https://apiv2-dev.vertown.com/",
	coreHostUrl: "https://apicore-dev.vertown.com/",
	sharedServicesHostUrl: "https://apisharedservices-dev.vertown.com/",
	residuesManagementHostUrl: "https://apiresiduesmanagement-dev.vertown.com/",
	suppliersHostUrl: "https://apisuppliers-dev.vertown.com/",
	residuesHostUrl: "https://apiresidues-dev.vertown.com/",
	integrationsHostUrl: "https://apiintegrations-dev.vertown.com/",
	newAngularUrl: "https://dev2.vertown.com/",
	// !############################################

	site: "https://vertown.com/",

	featureToggles: {
		permission: {
			destinatorModule: "C788F56C-65C5-4E36-8A41-F9B5E9CD11B2"
		},
		release: {
			changeLanguage: "155E500B-4963-401C-A9BC-AF7A41A94A4A",
			collectionRequestDisposal: "ed2eb769-cc4a-4ba1-98e0-7445ac8d73f0",
			collectionRequestInternalTransfer: "6b0e65aa-52a3-46f2-b218-494ec8537e5c",
			maturityModule: "C24BFC94-323C-4F56-B1B3-73E96F351782"
		}
	},

	loadingStates: {
		SUCCESS: 2,
		LOADING: 1,
		IDLE: 0,
		ERROR: -1
	},

	generalStatus: {
		success: 1,
		warning: 2,
		error: 3,
		info: 4,
		white: 5,
		black: 6
	},

	ANIMATION_DELAY: 1500,
	DEFAULT_ROWS_PER_PAGE: 20,

	applicationInsightsKey: "4ec69e42-4a4a-4eba-8c69-e144d5eb7d6b",

	// preenchido pelo gulp a partir de /version.json; "local" desliga a verificação de versão
	clientVersion: { build: "local", contract: 0 },

	content: {
		vertownBlueLogoLink: "public/logo_vertown_azul.svg",
		vertownBlackberryLogoLink: "public/logo_vertown_amora.png",
		vertownWhiteLogoLink: "public/logo_vertown_branca.svg",

		termsAndConditionsLink: "public/TermsAndConditions.pdf",
		privacyPolicyLink: "aviso-de-privacidade/",
		cookiePolicyLink: "public/cookiePolicy.pdf"
	},

	authentication: {
		client: "session.client",
		account: "session.user",
		previousLoggedSsoIdp: "session.idp",
		permissions: "currentUser.permissions",
		featureToggle: '"currentUser.featureToggle',
		appLogin: "appLogin",
		anonymousEndpoints: [
			".json",
			".js",
			".css",
			".svg",
			".html",
			"/identity-provider",
			"/v1/cities",
			"/v1/accounts",
			"/api/v1/site"
		],
		errors: {
			DefaultError: "DefaultError",
			PasswordResetRequiredException: "PasswordResetRequiredException",
			NotAuthorizedException: "NotAuthorizedException",
			UserNotConfirmedException: "UserNotConfirmedException",
			InvalidPasswordException: "InvalidPasswordException",
			InvalidParameterException: "InvalidParameterException"
		},
		forgotPasswordReturnTypes: {
			newPassword: "new_password",
			code: "code"
		},
		errorMessages: {
			UserDisabled: "User is disabled.",
			SessionExpired: "session is expired"
		},
		challenge: {
			newPasswordRequired: "NEW_PASSWORD_REQUIRED"
		}
	},

	featureToggleAccess: {
		Yes: "Yes",
		No: "No"
	},

	measureUnit: {
		Unit: {
			Id: 110,
			Group: 3
		},
		Ton: {
			Id: 109,
			Group: 2
		},
		Kilo: {
			Id: 108,
			Group: 2
		},
		LITER: {
			Id: 107,
			ConversionFactor: 0.001,
			Group: 1
		},
		M3: {
			Id: 106,
			ConversionFactor: 1,
			Group: 1
		}
	},

	country: {
		Brazil: 1,
		Peru: 169,
		Argentina: 13
	},

	httpStatus: {
		BadRequest: 400,
		Unauthorized: 401,
		Forbidden: 403,
		Notfound: 404
	},

	// events
	evtOpenMenu: "EVENT_OPEN_MENU",
	evtShowMenu: "EVENT_SHOW_MENU",
	evtShowErrorMessage: "EVENT_SHOW_ERROR_MESSAGE",
	evtShowWarningMessage: "EVENT_SHOW_WARNING_MESSAGE",
	evtShowInfoMessage: "EVENT_SHOW_INFO_MESSAGE",
	evtExecuteOperation: "EVENT_EXECUTE_OPERATION",
	evtShowSuccessMessage: "EVENT_SHOW_SUCCESS_MESSAGE",
	evtMenuLinkClick: "EVENT_MENU_LINK_CLICK",
	evtConfirmNo: "EVENT_OPERATION_DENIED",
	evtConfirmYes: "EVENT_OPERATION_ACCEPTED",
	evtExecuteAction: "EVENT_OPERATION_EXECUTE",
	evtConfirmOperation: "EVENT_SHOW_CONFIRM_OPERATION_TOAST",
	evtDestroyGrid: "EVENT_DESTROY_GRID",
	evtCloseToast: "CLOSE_TOAST",
	evtOpenUserMenu: "EVENT_OPEN_USER_MENU",
	evtCloseUserNavBar: "CLOSE_USER_NAV_BAR",
	evtChangeLoggedClient: "EVENT_CHANGE_CLIENT",
	evtConfimReplicateForClients: "EVENT_CONFIRM_REPLICATE_FOR_CLIENTS",
	evtGetSelectedCount: "EVENT_GET_SELECTED_COUNT",
	evtChangeLoggedUserInfo: "EVENT_CHANGE_LOGGED_USER_INFO",
	evtChangeLoggedClientInfo: "EVENT_CHANGE_LOGGED_CLIENT_INFO",
	evtChangeLoginStatus: "EVENT_CHANGE_LOGIN_STATUS",
	evtUpdateFollowUpList: "EVENT_UPDATE_FOLLOWUP",

	//Verta
	evtSearchInVerta: "SEARCH_IN_VERTA",

	//VertownNotification
	evtPreviewAlertNotification: "PREVIEW_ALERT_NOTIFICATION",

	//Iframe
	evtIframeOnSuccessCallBack: "onSuccessCall",

	evtIframeOnSuccessCreateDriver: "onSuccessCallCreateDriver",
	evtIframeOnCancelCreateDriver: "onCancelCallCreateDriver",
	evtIframeOnSuccessCreateVehicle: "onSuccessCallCreateVehicle",
	evtIframeOnCancelCreateVehicle: "onCancelCallCreateVehicle",
	evtIframeOnCancelDisposalDialogPagePopUp: "onCancelCallDisposalDialogPagePopUp",
	evtIframeOnSuccessCostDisposalDialogPagePopUp: "onSuccessCallCostDisposalDialogPagePopUp",
	evtIframeHeight: "onIframeHeight",

	// content nav bar events
	evtStartLoadingPage: "START_LOADING_PAGE",
	evtFinishLoadingPage: "FINISH_LOADING_PAGE",

	//authentication
	evtVgrLoginSuccess: "EVENT_VGR_LOGIN_SUCCESS",
	evtVgrLoginFailure: "EVENT_VGR_LOGIN_FAILURE",

	evtRefreshDisposalValidation: "refresh_disposal_validation",
	evtClientExternalSystemChanged: "client_external_system_changed",
	evtErrorCreatingDisposal: "error_creating_disposal",
	evtDisposalResiduesUpdated: "disposal_residues_updated",
	evtRecalculateDisposalCost: "recalculate_disposal_cost",
	evtDisposalCostChanged: "disposal_cost_changed",
	evtOpenDisposalCostPopup: "open_disposal_cost_popup",
	evtRecalculateDisable: "recalculate_disable",
	evtSetDisposalLoad: "set_disposal_load",
	events: {
		cache: {
			userPermission: "evt_cacheUserPermission",
			featureToggle: "evt_cacheFeatureToggle",
			user: "evt_cacheUser"
		},
		table: {
			headCheckboxSelected: "evt_tableHeadCheckboxSelected",
			headCheckboxUnSelected: "evt_tableHeadCheckboxUnSelected"
		}
	},

	MapLocations: {
		BELO_HORIZONTE_MG: new Cmp.constructors.MapPoint(-20, -44) //(-19.9166813, -43.9344931)//(-20,-44)//
	},

	cacheKeysPrefix: {
		images: "VGR_S3_IMAGES_CACHE_",
		measureUnits: "CORE_MEASURE_UNITS_CACHE_",
		scales: "SCALES_CACHE_",
		disposalTypes: "DISPOSAL_TYPE_CORE_CACHE_",
		countries: "LIST_COUNTRIES_CACHE_V2_",
		states: "LIST_STATES_CACHE_",
		cities: "CITIES_CACHE_"
	},

	VGclientID: 1,
	MasterOrganizationId: 1,
	IframeSingletonId: "newVertownSingleton",
	IframeSingletonBlankPage: "blank",
	IframeId: "portalAngular",
	// Guarda do reload disparado por RELOAD_PARENT. Uma vez por sessao da aba: se depois de
	// recarregar o iframe continuar dizendo que a rota nao existe, ela realmente nao existe.
	IframeStaleRouteReloadKey: "vgr.staleRouteReloadAttempted"
};
